(ns hai.mini-apps.data
  "The mini-apps a surface renders: the platform's list for the requesting
   surface, keyed by tool, each carrying its collapsed flag for that surface."
  (:require
   [hai.ui.rf-sugar :refer [defevent defevent-fx defsub]]))

(def ^:private mini-app-eql
  [:mini-app/uuid
   :mini-app/tool
   :mini-app/title
   :mini-app/description
   :mini-app/config
   :mini-app/beta?
   :mini-app/collapsed?])

(defevent-fx ::load [_ {:keys [on-success-fx]}]
  {:resolve {:query [(list {:user/mini-apps mini-app-eql} {:mini-apps/only-active? true})]
             :store-in [::by-tool]
             :transform-fn (fn [resp]
                             (into {} (map (juxt :mini-app/tool identity)) (:user/mini-apps resp)))
             :on-success-fx (vec on-success-fx)}})

(defevent ::clear [db _]
  (dissoc db ::by-tool))

(defn tools
  "The tools of the loaded mini-apps."
  [db]
  (keys (::by-tool db)))

(defsub ::by-tool [db]
  (::by-tool db))

(defsub ::loaded?
  [by-tool <- ::by-tool]
  (some? by-tool))

(defsub ::collapsed?
  [tool
   by-tool :<- ::by-tool]
  (boolean (get-in by-tool [tool :mini-app/collapsed?])))

(defn- set-collapsed
  "Flips the flag locally and records it as the mini-app's placement on this
   surface."
  [db tool collapsed?]
  {:db (assoc-in db [::by-tool tool :mini-app/collapsed?] collapsed?)
   :resolve {:query [(list 'placement/update {:mini-app/uuid (get-in db [::by-tool tool :mini-app/uuid])
                                              :fields {:collapsed? collapsed?}})]}})

(defevent-fx ::toggle-collapsed [{:keys [db]} tool]
  (set-collapsed db tool (not (get-in db [::by-tool tool :mini-app/collapsed?]))))

;; A card about to show something new — a composer, a fresh pad — opens first,
;; the way the extension's cards do.
(defevent-fx ::expand [{:keys [db]} tool]
  (when (get-in db [::by-tool tool :mini-app/collapsed?])
    (set-collapsed db tool false)))
